import './modern_modal_with_header.less';

/*
 * This is a new modern Modal style that was adopted at the end of 2021. It
 * includes a stepped button component which can be used for multi-step modal
 * displays.
 *
 * The body of the modal is best displayed using the following format:
 *
 * <h2>VIEW TITLE</h2>
 *
 * <p>Some text...</p>
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import map from 'lodash/map';
import range from 'lodash/range';

import Link from 'zoomforth_component_lib/basic_link.jsx';
import Button from 'zoomforth_component_lib/btn_basic.jsx';
import SimpleModalWithHeader from 'zoomforth_component_lib/simple_modal_with_header.jsx';


const ModernModalSteppedActions = ({
  className,
  isLeftBtnDisabled,
  isRightBtnDisabled,
  leftBtnDisabledReason,
  rightBtnDisabledReason,
  leftBtnContent,
  rightBtnContent,
  shouldShowStepIndicator,
  totalSteps,
  currentStepNum,
  onLeftBtnClick,
  onRightBtnClick
})=> (
  <div className={classNames('modern-modal-actions', className)}>
    <Link
      className="left-btn-action"
      disabled={isLeftBtnDisabled}
      tooltip={leftBtnDisabledReason}
      onClick={onLeftBtnClick}
    >
      { leftBtnContent }
    </Link>

    {
      shouldShowStepIndicator &&
        <div className="step-indicator">
          {
            map(range(1, totalSteps + 1), (step)=> (
              <span
                key={step}
                className={classNames('step-indicator', {
                  'is-step-highlighted': step <= currentStepNum,
                  'is-current-step': step === currentStepNum
                })}
              />
            ))
          }
        </div>
    }

    <Button
      primary
      tooltip={rightBtnDisabledReason}
      disabled={isRightBtnDisabled}
      className="right-btn-action"
      onClick={onRightBtnClick}
    >
      { rightBtnContent }
    </Button>
  </div>
);

ModernModalSteppedActions.defaultProps = {
  shouldShowStepIndicator: true,
  isLeftBtnDisabled: false,
  isRightBtnDisabled: false
};

ModernModalSteppedActions.propTypes = {
  className: PropTypes.string,
  isLeftBtnDisabled: PropTypes.bool.isRequired,
  isRightBtnDisabled: PropTypes.bool.isRequired,
  leftBtnDisabledReason: PropTypes.string,
  rightBtnDisabledReason: PropTypes.string,
  leftBtnContent: PropTypes.node,
  rightBtnContent: PropTypes.node,
  shouldShowStepIndicator: PropTypes.bool.isRequired,
  totalSteps: PropTypes.number,
  currentStepNum: PropTypes.number,
  onLeftBtnClick: PropTypes.func,
  onRightBtnClick: PropTypes.func
};

const ModernModalWithHeader = ({
  show,
  title,
  subtitle,
  children,
  className,
  isExpanded,
  onRequestClose
})=> (
  <SimpleModalWithHeader 
    show={show}
    title={title}
    subtitle={subtitle}
    className={classNames('modern-modal-with-header', className, {
      'is-expanded': isExpanded,
      'has-subtitle': !!subtitle
    })}
    onRequestClose={onRequestClose}
  >
    { children }
  </SimpleModalWithHeader>
);

ModernModalWithHeader.defaultProps = {
  show: true,
  isExpanded: false
};

ModernModalWithHeader.propTypes = {
  show: PropTypes.bool.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  onRequestClose: PropTypes.func.isRequired
};

export {
  ModernModalWithHeader,
  ModernModalSteppedActions
};

export default ModernModalWithHeader;
